import { AvatarUpload } from '@/components/ui/avatar-upload';
import { FormControl, FormItem, FormMessage } from '@/components/ui/form';
import type { FieldComponentProps } from '../fieldRegistry';
import type { AvatarUploadFieldConfig } from '@/types/formFields';
import type { AnyFieldConfig } from '../types';

interface AvatarUploadFieldProps
  extends Omit<FieldComponentProps<string>, 'field' | 'value'> {
  field: AnyFieldConfig & {
    avatarConfig?: AvatarUploadFieldConfig;
  };
  /**
   * react-hook-form hands `undefined` for an unset optional image field. The prop is
   * declared optional rather than defaulted at the call site because the underlying
   * `AvatarUpload` distinguishes `undefined` (fall back to `currentImageId`) from
   * `''` (the user explicitly removed the image) — see avatar-upload.tsx:58.
   */
  value?: string;
  onUploadingChange?: (isUploading: boolean) => void;
}

export function AvatarUploadField({
  field,
  value,
  onChange,
  onBlur,
  disabled,
  onUploadingChange,
}: AvatarUploadFieldProps) {
  const avatarConfig = field.avatarConfig || {
    size: 'lg',
  };

  return (
    <FormItem className="flex flex-col items-center w-full justify-center py-4">
      <FormControl>
        <AvatarUpload
          value={value}
          onChange={(imageId) => {
            onChange(imageId || '');
            onBlur();
          }}
          onUploadingChange={onUploadingChange}
          disabled={disabled || field.disabled}
          entityType={avatarConfig.entityType}
          entityId={avatarConfig.entityId}
          size={avatarConfig.size}
          currentImageUrl={avatarConfig.currentImageUrl}
          currentImageId={avatarConfig.currentImageId}
        />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
}